import { render, staticRenderFns } from "./ModalAnularContrato.vue?vue&type=template&id=4059482f"
import script from "./ModalAnularContrato.vue?vue&type=script&lang=ts"
export * from "./ModalAnularContrato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports